"use client";

import { useEffect, useState, useCallback } from 'react';

export type PhoneCaptureTrigger = 'exit' | 'time' | null;

export const usePhoneCaptureTrigger = (
    delay: number = 2 * 60 * 1000,
    activePage?: string,
) => {
    const [trigger, setTrigger] = useState<PhoneCaptureTrigger>(null);

    const reset = useCallback(() => {
        setTrigger(null);
    }, []);

    useEffect(() => {
        reset();
        const timerId = setTimeout(() => {
            setTrigger('time');
        }, delay);

        return () => clearTimeout(timerId);
    }, [delay, activePage, reset]);

    useEffect(() => {
        const handleMouseOver = (event: MouseEvent) => {
            const target = event.target as HTMLElement | null;
            if (!target) return;

            const header = target.closest('header');
            if (!header) return;

            const ul = header.querySelector('nav ul');
            if (!ul) return;

            const { clientX, clientY } = event;
            const rect = ul.getBoundingClientRect();

            const isInUlSafeZone =
                clientX >= rect.left &&
                clientX <= rect.right &&
                clientY >= rect.top - 100 &&
                clientY <= rect.bottom + 100;

            if (!isInUlSafeZone) {
                setTrigger('exit');
            }
        };

        document.addEventListener('mouseover', handleMouseOver);
        return () => document.removeEventListener('mouseover', handleMouseOver);
    }, [setTrigger, activePage]);

    return {
        trigger, // 'exit' | 'time' | null
        reset,
    };
};

